import type { ReactNode } from "react";
import { FileDropZone } from "../components/FileDropZone.tsx";

/**
 * Drop a photo from the computer onto this area, as well as choosing it with the button inside.
 * While a file is over the area, it shows "Drop the photo here". Only the first file is taken, and
 * only an image.
 */
export function PhotoDropZone({
  onFile,
  onReject,
  disabled = false,
  className = "",
  children,
}: {
  onFile: (file: File) => void;
  /** A drop that is not an image file: the words to show the person. */
  onReject: (message: string) => void;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}) {
  function onFiles(files: File[]) {
    const file = files[0];
    if (!file) {
      onReject("Drop a photo file from your computer: a JPG, PNG or WebP.");
      return;
    }
    if (file.type && !file.type.startsWith("image/")) {
      onReject("This is not a photo. Drop a JPG, PNG or WebP file.");
      return;
    }
    onFile(file);
  }

  return (
    <FileDropZone label="Drop the photo here" onFiles={onFiles} disabled={disabled} className={className}>
      {children}
    </FileDropZone>
  );
}
